import { formatarBRL } from './formato';

/*
 * Troco do pagamento em dinheiro na entrega/retirada (chamado #137). Sem ele o
 * entregador sai sem saber quanto levar. A comparação é em centavos: o total
 * vem de soma de preço × quantidade e 0.1 + 0.2 vira 0.30000000000000004 no
 * ponto flutuante, o que recusaria a nota exata que o cliente digitou.
 */

const emCentavos = (valor: number): number => Math.round(valor * 100);

/**
 * Valor digitado no campo; `null` = vazio. Aceita um separador decimal (ponto
 * ou vírgula) ou milhar com ponto antes da vírgula ("1.000,50"). O resto vira
 * `NaN`: apagar pontos às cegas transformava "50.00," em 5000.
 */
export function lerValorTroco(texto: string): number | null {
  const limpo = texto.trim();
  if (!limpo) return null;
  if (/^\d{1,3}(\.\d{3})+(,\d*)?$/.test(limpo)) return Number(limpo.replace(/\./g, '').replace(',', '.'));
  if (/^\d*[.,]?\d*$/.test(limpo)) return Number(limpo.replace(',', '.'));
  return Number.NaN;
}

/** Troco informado que não cobre o total — ou que nem é número. */
export function trocoInsuficiente(troco: number | null, total: number): boolean {
  return troco !== null && (!Number.isFinite(troco) || emCentavos(troco) < emCentavos(total));
}

/** Quanto volta para o cliente; zero quando é o valor exato. */
export function valorDoTroco(troco: number, total: number): number {
  return Math.max(0, emCentavos(troco) - emCentavos(total)) / 100;
}

/**
 * Linha do resumo, que só o cliente lê (o entregador recebe o número no
 * pedido). Mesma palavra do popup: "você recebe".
 */
export function descreverTroco(troco: number | null, total: number): string | null {
  if (trocoInsuficiente(troco, total)) return null;
  if (troco === null) return 'Não precisa de troco';
  const volta = valorDoTroco(troco, total);
  if (volta === 0) return 'Valor exato, sem troco';
  return `Troco para ${formatarBRL(troco)} · você recebe ${formatarBRL(volta)} de volta`;
}

/** Valores redondos logo acima do total, para o cliente tocar em vez de digitar. */
export function sugerirNotas(total: number): number[] {
  const centavos = emCentavos(total);
  const notas = new Set<number>();
  // floor + 1: a nota igual ao total não é troco, pula para a próxima.
  for (const passo of [10, 20, 50, 100, 200]) notas.add((Math.floor(centavos / (passo * 100)) + 1) * passo);
  return [...notas].sort((a, b) => a - b).slice(0, 3);
}
